import { render, staticRenderFns } from "./mcp-documentation.vue?vue&type=template&id=77acf5ec&scoped=true&"
import script from "./mcp-documentation.vue?vue&type=script&lang=js&"
export * from "./mcp-documentation.vue?vue&type=script&lang=js&"
import style0 from "./mcp-documentation.vue?vue&type=style&index=0&id=77acf5ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77acf5ec",
  null
  
)

export default component.exports